/* eslint-disable jsx-a11y/alt-text */
import dayjs from "dayjs";
import "./collection.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../../App.css";
import { useCompany } from "../../components/context/CompanyContext";
import { userRequest } from "../../requestMethods";
import { titleSetRef } from "../../redux/titleRedux";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { generateFileUrl } from "../../requestMethods";
import { Button } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { MultiSelect } from "react-multi-select-component";

export default function Collection() {
  const [data, setData] = useState();
  const [dataIni, setDateIni] = useState();
  const [dataFim, setDateFim] = useState();
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const [readonly, setReadonly] = useState();
  const [cats, setCats] = useState([]);
  const [selected, setSelected] = useState([]);
  const [modalImg, setModalImg] = useState(null);
  const nav = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(titleSetRef({ title: "Acervo" }));
    setReadonly("7");
    if (companyId > 0) {
      getCollection();
    }
    setDateIni(dayjs(new Date()).add(-7, "day").format("YYYY-MM-DD"));
    setDateFim(dayjs(new Date()).format("YYYY-MM-DD"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  useEffect(() => {
    if (companyId > 0) {
      getCollection();
      getCollectionCategories();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIni, dataFim, selected]);

  const handleChangeCat = (newSelected) => {
    // pega o último item clicado
    const last = newSelected[newSelected.length - 1];

    if (last?.isGroup) {
      // pega todos os itens do grupo
      const itemsDoGrupo = cats.filter((opt) => opt.group === last.value);

      // adiciona ao selecionado
      const semGrupo = newSelected.filter((opt) => !opt.isGroup);
      const novoSelecionado = [...semGrupo, ...itemsDoGrupo];

      setSelected(novoSelecionado);
    } else {
      setSelected(newSelected.filter((opt) => !opt.isGroup));
    }
  };
  const getCollection = async () => {
    try {
      let obj = {
        start: dataIni,
        end: dataFim,
        categories: selected.map((cat) => cat.value),
      };

      if (dataIni && dataFim) {
        const res = await userRequest.post(
          `${companyId}/products/collection`,
          obj
        );
        setData(res.data);
      }
    } catch {}
  };

  const getCollectionCategories = async () => {
    try {
      if (dataIni && dataFim) {
        const res = await userRequest.get(
          `${companyId}/products/categories/collection`
        );
        setCats(res.data);
      }
    } catch {}
  };
  const handleChangeStart = (e) => {
    setDateIni(e.target.value);
  };
  const handleChangeEnd = (e) => {
    setDateFim(e.target.value);
  };
  const handleChange = (event) => {
    setReadonly(event.target.value);
    // eslint-disable-next-line default-case
    switch (event.target.value) {
      case "0":
        setDateIni(dayjs(new Date()).format("YYYY-MM-DD"));
        setDateFim(dayjs(new Date()).format("YYYY-MM-DD"));
        break;
      case "7":
        setDateIni(dayjs(new Date()).add(-7, "day").format("YYYY-MM-DD"));
        setDateFim(dayjs(new Date()).format("YYYY-MM-DD"));
        break;
      case "15":
        setDateIni(dayjs(new Date()).add(-15, "day").format("YYYY-MM-DD"));
        setDateFim(dayjs(new Date()).format("YYYY-MM-DD"));
        break;
      case "30":
        setDateIni(dayjs(new Date()).add(-30, "day").format("YYYY-MM-DD"));
        setDateFim(dayjs(new Date()).format("YYYY-MM-DD"));
        break;
    }
  };

  return (
    <div className="div_home_Container">
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "flex-end", // tudo alinhado à direita
          gap: "20px",
        }}
      >
        {/* Radios */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <label>
            <input
              type="radio"
              value="30"
              onChange={handleChange}
              checked={readonly === "30"}
            />
            30 dias
          </label>
          <label>
            <input
              type="radio"
              value="15"
              onChange={handleChange}
              checked={readonly === "15"}
            />
            15 dias
          </label>
          <label>
            <input
              type="radio"
              value="7"
              onChange={handleChange}
              checked={readonly === "7"}
            />
            7 dias
          </label>
          <label>
            <input
              type="radio"
              value="0"
              onChange={handleChange}
              checked={readonly === "0"}
            />
            Hoje
          </label>
          <label>
            <input
              type="radio"
              value="F"
              onChange={handleChange}
              checked={readonly === "F"}
            />
            Filtro
          </label>
        </div>

        {/* Filtrar sempre visível */}
        <div className="datePicker">
          <label className="labelPeriodo">
            Filtrar:
            <input
              type="date"
              id="startDate"
              value={dataIni}
              name="trip-start"
              min="2023-01-01"
              onChange={handleChangeStart}
              disabled={readonly !== "F"} // mantém a lógica de bloquear quando não for "F"
            />
            <input
              type="date"
              id="endDate"
              value={dataFim}
              name="trip-start"
              min="2023-01-01"
              onChange={handleChangeEnd}
              disabled={readonly !== "F"}
            />
          </label>
        </div>

        {/* MultiSelect */}
        <div style={{ minWidth: "250px" }}>
          <MultiSelect
            overrideStrings={{
              selectAll: "Todos",
              search: "Buscar",
              selectSomeItems: "Categorias",
              allItemsAreSelected: "Todas categorias selecionadas.",
              noOptions: "Nehuma categoria",
            }}
            options={cats}
            value={selected}
            onChange={handleChangeCat}
            labelledBy="Selecione"
            hasSelectAll={false}
            ItemRenderer={({ checked, option, onClick }) => {
              if (option.isGroup) {
                return (
                  <div
                    style={{
                      fontWeight: "bold",
                      margin: "6px 0",
                      cursor: "pointer",
                    }}
                    onClick={onClick}
                  >
                    📂 {option.label}
                  </div>
                );
              }
              return (
                <div className="item-renderer">
                  <input type="checkbox" checked={checked} onChange={onClick} />
                  <span>{option.label}</span>
                </div>
              );
            }}
          />
        </div>
      </div>

      <table width="100%">
        <tr>
          <div>
            {data &&
              data.map((item) =>
                item.imgs.map((img) =>
                  img.imagens.map((i) => (
                    <div
                      className="image-container"
                      key={i}
                      onClick={() => setModalImg(generateFileUrl(i))}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        className="imgSize"
                        src={generateFileUrl(i)}
                        loading="lazy"
                      />
                      <div className="overlay">{img.ref}</div>
                    </div>
                  ))
                )
              )}
          </div>
          {modalImg && (
            <div className="modal" onClick={() => setModalImg(null)}>
              <span className="close">&times;</span>
              <img
                className="modal-content"
                src={modalImg}
                alt="preview"
                onClick={(e) => e.stopPropagation()} // evita fechar ao clicar na imagem
              />
            </div>
          )}
        </tr>
      </table>
    </div>
  );
}
